export default __webpack_public_path__ + "static/media/colorStates.16ae2d58.gif";